module.exports = __webpack_public_path__ + "img/26W-4558T00x.afeb7f78.png";